import createCachedSelector from 're-reselect'

import selectIntegrationSettingsByProvider from './selectIntegrationSettingsByProvider'

export default createCachedSelector(
  selectIntegrationSettingsByProvider,
  (_, { provider }) => provider,
  (byProvider, provider) => {
    return {
      foo: 'bar', // We need something to render the form
      ...byProvider[provider],
    }
  }
)((state, { provider }) => provider)
